import Service from "@services/Service";
import { WEB_API_ENDPOINT } from "@utils/awsAmplify";

class User extends Service {
  static getUser(username) {
    return User.get(WEB_API_ENDPOINT, "/user", {
      queryStringParameters: {
        username,
      },
    });
  }

  static getUsers() {
    return User.get(WEB_API_ENDPOINT, "/users");
  }

  static find(userName) {
    return User.get(WEB_API_ENDPOINT, `/users/${userName}`);
  }

  static updateUser(userName, data) {
    return User.put(WEB_API_ENDPOINT, `/users/${userName}`, { body: data });
  }

  static getUserGroups(userName) {
    return User.get(WEB_API_ENDPOINT, `/users/${userName}/groups`);
  }

  static deleteUser(userName) {
    return User.del(WEB_API_ENDPOINT, `/users/${userName}`);
  }

  static resendInvitation(userName) {
    return User.post(WEB_API_ENDPOINT, `/users/${userName}/resend_invitation`);
  }

  static getGroups() {
    return User.get(WEB_API_ENDPOINT, "/groups");
  }

  static addUserToGroup(group, userName) {
    return User.put(WEB_API_ENDPOINT, `/groups/${group}/users/${userName}`);
  }

  static deleteUserFromGroup(group, userName) {
    return User.del(WEB_API_ENDPOINT, `/groups/${group}/users/${userName}`);
  }

  static createUser(group, data) {
    return User.post(WEB_API_ENDPOINT, `/groups/${group}/users`, {
      body: data,
    });
  }
}

export default User;
